import point from "../point";
import line from "../line";

const Polygon = (pointsCords, clonePoint = false, canPointsBeMoved = false) => {
  let points = [];
  let lines = [];

  for (let pointCord of pointsCords) {
    let newPoint = new point(pointCord.x, pointCord.y, undefined, undefined, canPointsBeMoved)
    if (clonePoint && pointCord instanceof point) {
      newPoint.import(pointCord.export());
    }
    points.push(newPoint);
  }
  for (let i in points) {
    if (points[+i + 1]) {
      lines.push(new line(points[i], points[+i + 1]))
    } else {
      lines.push(new line(points[i], points[0]))
    }
  }

  return lines;
};

export default Polygon
